// extracted by mini-css-extract-plugin
module.exports = {"customer":"DeliveryStatus_customer__2l1Oa","button":"DeliveryStatus_button__1uRG1","underline":"DeliveryStatus_underline__MRjGl"};